<style lang="sass" scoped>
  @import '../../../sass/variables'

  .radial
    height: 100px

    .chart
      width: 125px
      margin-left: -40px

    .detail
      margin-top: 25px

      .title
        width: 100%
        font-size: 0.75rem
        text-transform: uppercase
        font-weight: 400
        color: $salesflow-font-dark
        line-height: 130%

      .value
        width: 100%
        font-size: 1.25rem
        font-weight: 600
        line-height: 130%

        small
          font-size: 0.75rem
          font-weight: 300

    .detail.large
      margin-top: 20px

      .value
        font-size: 1.75rem
</style>

<template>
  <div class="radial d-inline-flex">
    <div class="chart">
      <Apexchart
        width="152"
        type="radialBar"
        :series="series"
        :options="options"
      />
    </div>
    <div
      class="detail"
      :class="{ large: large }"
    >
      <div class="title">
        {{ title }}
      </div>
      <div
        class="value"
        :style="{ color: colors[0] }"
      >
        <small>R$</small>
        {{ value | number(0) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'value', 'percent', 'colors', 'large'],

  data () {
    return {
      series: [this.percent],
      options: {
        labels: [''],
        plotOptions: {
          radialBar: {
            startAngle: 0,
            // endAngle: 225,
            hollow: {
              margin: 0,
              size: '65%',
              background: '#fff',
              image: undefined,
              imageOffsetX: 0,
              imageOffsetY: 0,
              position: 'front',
              dropShadow: {
                enabled: true,
                top: 1,
                left: 0,
                blur: 1,
                opacity: 0.24,
              },
            },
            track: {
              background: '#F0F0F0',
              strokeWidth: '67%',
              margin: 1, // margin is in pixels
              dropShadow: {
                enabled: false,
              }
            },
            dataLabels: {
              showOn: 'always',
              name: {
                show: false,
              },
              value: {
                show: true,
                offsetY: 5,
                formatter (val) {
                  return `${parseInt(val)}%`;
                },
                color: '#111',
                fontSize: '16px',
                fontFamily: 'Montserrat',
                fontWeight: 400,
              },
            },
          },
        },
        fill: {
          colors: [this.colors[0]],
          type: 'gradient',
          gradient: {
            type: 'vertical',
            shadeIntensity: 1,
            opacityFrom: 1,
            opacityTo: 1,
            gradientToColors: [this.colors[1]],
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
      },
    };
  },
};
</script>
